/** Session flag: after a wallet reset, next boot should offer create vs restore
 *  instead of silently minting a new phrase (TMA first-open still auto-creates). */
const KEY = 'incpt_wallet_setup_offer';

export function markWalletSetupOffer(): void {
  try {
    sessionStorage.setItem(KEY, '1');
  } catch {
    /* private mode */
  }
}

export function consumeWalletSetupOffer(): boolean {
  try {
    if (sessionStorage.getItem(KEY) !== '1') return false;
    sessionStorage.removeItem(KEY);
    return true;
  } catch {
    return false;
  }
}
